import * as React from "react";

export interface PhonepeContextValue {
    isPhonepeSdkAvailable: boolean;
}

export const PhonepeContext = React.createContext<PhonepeContextValue>({ isPhonepeSdkAvailable: false });

if (__DEV__) {
    PhonepeContext.displayName = "PhonepeContext";
}
